import { render, staticRenderFns } from "./VpayDialog.vue?vue&type=template&id=22baa688&scoped=true&"
import script from "./VpayDialog.vue?vue&type=script&lang=js&"
export * from "./VpayDialog.vue?vue&type=script&lang=js&"
import style0 from "./VpayDialog.vue?vue&type=style&index=0&id=22baa688&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22baa688",
  null
  
)

export default component.exports